<template>
  <div>
    <div class="contain">
      <img src="@/assets/img/logo-shopvidi-new.png" height="40px" width="160px"/>
      <el-divider />
      <el-steps
        class="pc-steps"
        :active="active"
        finish-status="success"
        align-center
      >
        <el-step title="Register"></el-step>
        <el-step title="Profile"></el-step>
        <el-step title="Complete"></el-step>
      </el-steps>
      <Profile v-if="active === 2" @gotoReview="gotoReview"/>
      <BrandReviewResult v-if="active === 3" :isApproved="isApproved"/>
    </div>
  </div>
</template>

<script>
import BrandReviewResult from './brand-review-result.vue'
import Profile from './profile.vue'
export default {
  components: {
    Profile,
    BrandReviewResult
  },
  data() {
    return {
      active: 2,
      isApproved: null
    }
  },
  created() {
    // 根据参数觉得显示 表单还是结果
    if (this.$route.query.result === 'inReview') {
      this.active = 3
    }
    if (this.$route.query.result === 'declined') {
      this.active = 3
      this.isApproved = false
    }
    if (this.$route.query.result === 'approved') {
      this.active = 3
      this.isApproved = true
    }
  },
  methods: {
    gotoReview() {
      // this.active = 3
      this.$router.push('/')


    }
  }
}
</script>

<style lang="less" scoped>
/* 步骤条样式修改 */
/deep/ .el-step__title.is-wait {
  color: #8f8f8f !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  color: #8f8f8f;
  opacity: 1;
}
/deep/ .el-steps.el-steps--horizontal {
  width: 40%;
  margin: 0 auto;
  margin-top: 30px;
}
/deep/ .el-step__head.is-success {
  div:nth-child(2){
    background-color: #000000 !important;
    color: #FFFFFF !important;
  }
  color: #000000 !important;
  border-color: #000000 !important;
}
/deep/ .el-step__title.is-success {
  color: #000000 !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  color: #262b2f;
  opacity: 1;
}
/deep/ .el-step__head.is-process {
  color: #8f8f8f !important;
  border-color: #8f8f8f !important;
}
/deep/ .el-step__title.is-process {
  color: #8f8f8f !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  color: #262b2f;
  opacity: 1;
}

.contain {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 84px;
  .payment-first-shopvidi-logo {
    height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/brand-review/brand-review.vue